import { useGetInstallationFullQuery } from 'generated/graphql';
import {
  ProjectInstallationDetailSection,
  ProjectInstallationHeaderSection,
  StyledActivityCardBackground
} from 'modules';
import React from 'react';
import { useParams } from 'react-router-dom';



export type InstallationActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const InstallationActivity = (props: InstallationActivityProps) => {
  const params = useParams();
  // using to preload
  useGetInstallationFullQuery({
    variables: {
      id: params.installationId ?? ''
    },
    skip: params.installationId === ''
  });
  return (
    <StyledActivityCardBackground.FC>
      <ProjectInstallationHeaderSection.FC />
      <ProjectInstallationDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
